import { render } from "./Admin.vue?vue&type=template&id=04276f0a&scoped=true"
import script from "../js/admin.js?vue&type=script&lang=js"
export * from "../js/admin.js?vue&type=script&lang=js"

import "./Admin.vue?vue&type=style&index=0&id=04276f0a&scoped=true&lang=css"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/disposhop_jars/dispo_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04276f0a"]])

export default __exports__